const index = () => import('./Index');

export default {
  routes: [
    //项目
    {
      path: '/intelligent/index',
      name: 'intelligentIndex',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/intelligent/V2018/router.js